import PropTypes from "prop-types";
import Title from "components/shared/stays/Title";
import RegionListItem from "components/destination/RegionListItem";
import styles from "components/destination/RegionList.module.scss";

export default function RegionList({ regions }) {
  return (
    <div className={styles.component}>
      <Title tag="h2" size={4}>
        Local regions
      </Title>
      <div className={styles.list}>
        {Object.entries(regions)
          .sort((a, b) => a[0].localeCompare(b[0]))
          .map(([key, val]) => (
            <RegionListItem
              name={key}
              mainImage={val.image.url}
              key={key}
              url={`/destinations/${val.slug}`}
            />
          ))}
      </div>
    </div>
  );
}

RegionList.propTypes = {
  regions: PropTypes.objectOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
    })
  ),
};
